import Rails from "@rails/ujs";
Rails.start()
window.Rails = Rails;

import './add_tether'
import './add_jquery'
import 'jquery-ui-dist/jquery-ui'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap-datepicker/js/bootstrap-datepicker'
import 'medium-editor/dist/js/medium-editor'

import 'selectize'

import './vendor/frontend/jquery.gridder/jquery.gridder'
import './vendor/frontend/jquery.scrollTo/jquery.scrollTo'
import './vendor/frontend/superfish/hoverIntent'
import './vendor/frontend/superfish/superfish'
import './vendor/frontend/jquery.validate.min'
import './vendor/frontend/sly'

import 'chart.js'

import './cookies-eu-banner'

import './modules/contact-form'

import './helpers/element_exists'
import './helpers/is-mobile'
import './helpers/jquery.easings'
import './helpers/jquery.smartresize'
import './helpers/string-helpers'

import './behaviors/_chart-config'
import './behaviors/bar-chart'
import './behaviors/equal-height'
import './behaviors/expand-content'
import './behaviors/form-disclaimer'
import './behaviors/pie-chart'
import './behaviors/region-office-loader'
import './behaviors/searchbar'
import './behaviors/stacked-line-chart'
import './behaviors/switch-contact'
import './behaviors/tracking-helper'
import './behaviors/vertical-center'

import './vendor/google/autotrack'
import './vendor/jquery.scrollTo/jquery.scrollTo'
import './vendor/superfish/hoverIntent'
import './vendor/superfish/superfish'

import './frontend/library-page'
import './frontend/main-nav'
import './frontend/tender-page'
import './frontend/training-page'
import './frontend/vacancy'


function selectize_all_selects() {
  $('select:visible:not(.no-selectize)').not('.selectized').each(function (i, select) {
    $select = $(select);
    $select.selectize({
      onChange: function (value) {
        var link_to = $select.data("dashboard-link");
        if (link_to !== undefined && value !== '') {
          window.location.href = link_to + "/" + value
        } else if ($select.data("autosubmit")) {
          $select.get(0).form.submit();
        }
      }
    });
  });
}

$(function() {
  var url = document.location.toString();
  if (url.match('#')) {
    $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
  }

  // Change hash for page-reload
  $('.nav-tabs a').on('shown.bs.tab', function (e) {
    var target = e.target.hash;
    window.location.hash = target;
  });
});

$(function() {
  var $frame = $('.slider__container');
  var $wrap  = $frame.parent();

  // Call Sly on frame
  var panel_slyder = $frame.sly({
    horizontal: 1,
    itemNav: 'forceCentered',
    smart: 1,
    activateMiddle: 1,
    activatePageOn: 'click',
    mouseDragging: 1,
    touchDragging: 1,
    releaseSwing: 1,
    startAt: 0,
    scrollBy: 1,
    speed: 300,
    elasticBounds: 1,
    dragHandle: 1,
    dynamicHandle: 1,
    clickBar: 1,

    pagesBar: $wrap.find('.slider__pager'),
  });

  $(window).smartresize(function(){
    if (panel_slyder != null) {
      panel_slyder.sly('reload');
    }
  });

  var enabledTabs = [
    '#shareholder-tab-1 a',
    '#shareholder-tab-2 a',
    '#shareholder-tab-3 a',
    '#pool-tab-1 a',
    '#pool-tab-2 a',
  ];

  $.each(enabledTabs, function(index, element) {
    $(element).click(function (e) {
      $(this).tab('show');
      $.scrollTo($(element), {
        offset: -($(element).height())
      })
      e.preventDefault();
    });
  });

  // register sliding content handler
  $('.gridder').gridderExpander({
      scroll: true,
      scrollOffset: 30,
      scrollTo: "listitem",                  // panel or listitem
      animationSpeed: 400,
      animationEasing: "swing",
      showNav: true,                      // Show Navigation
      nextText: "",                   // Next button text
      prevText: "",               // Previous button text
      closeText: "",                 // Close button text
      onContent: function(){
          //Gridder Content Loaded
          selectize_all_selects();
          $('input, textarea').placeholder();
      }
  });
  $('.carousel').carousel();
  selectize_all_selects();

  var superSearch = document.getElementById( 'sb-search' );
  if (superSearch != null) {
    new UISearch( superSearch );
  }

  // this should be in controller specific JS

  $('form.auto-submit').find('select').on('change', function(event, data) {
    $(this).closest('form').submit();
  });

  ExpandContent.expandContentHandler();
});
